export const DownloadJSPMDriver = () => {
    const link = document.createElement("a");
    link.href="/assets/jspm7-7.0.0.0-win.exe"
    link.download = 'jspm7-7.0.0.0-win.exe';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link)
}